import ProductDetailModal from './ProductDetailModal.container'

export default ProductDetailModal
